import { ApiMode } from '@vsolv/core/multi-tenant/domain';

export const apiMode: ApiMode = ApiMode.LIVE;
